import { FormsActionTypes, IBaseAction, panelType } from '@bimser/common';
import { createSyncAction } from '@bimser/core';
import { put, select, takeEvery } from 'redux-saga/effects';
import { SetPanelActionFactoryFromJS } from '../entities';

export default function* watchFormUpdateSecretKey() {
	yield takeEvery(FormsActionTypes.FORM_UPDATE_SECRET_KEY_SAGA, formUpdateSecretKey);
}

export function* formUpdateSecretKey(sagaAction: IBaseAction<any>) {
	const payload = sagaAction.payload;
	const formId: string = payload.windowId;
	const documentId: number = payload.documentId;
	const secretKey: number = payload.secretKey;
	const view: string = payload.view;

	const [panelId] = formId.split('_');

	let panelData = yield select(getFlowViewerPanelData(panelId));
	if (panelData) {
		const activeDocumentName = panelData.activeDocumentName;
		const documentIndex = panelData.documents?.findIndex(
			(d: { documentKey: string }) => d.documentKey === activeDocumentName
		);

		const saveOptions = panelData.documentsForms
			.get(activeDocumentName)
			.saveOptions.map((item: { eventId: string }) => ({
				...item,
				secretKey
			}));

		panelData = panelData.setIn(['documents', documentIndex, 'documentId'], documentId);
		panelData = panelData.setIn(['documents', documentIndex, 'viewOptions', 'viewName'], view);
		panelData = panelData.setIn(
			['documentsForms', activeDocumentName, 'saveOptions'],
			saveOptions
		);
		panelData = panelData.setIn(['documentsForms', activeDocumentName, 'viewName'], view);

		yield put(
			createSyncAction(
				FormsActionTypes.SET_PANEL_CONTENT_ACTION,
				SetPanelActionFactoryFromJS({
					panelId,
					panelType: panelType.flowViewer,
					data: panelData
				})
			)
		);
	}
}

const getFlowViewerPanelData = (panelId: string) => state =>
	state.modules.workflow.panels.flowViewerForms.get(panelId);
